import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'mdbreact/dist/css/mdb.css';
import './index.css';

import { BrowserRouter , Switch ,Route} from 'react-router-dom';
import { Provider } from 'react-redux'
import {store,persistor} from './redux/store';
import { PersistGate } from 'redux-persist/integration/react'
import Login from './screens/login/login'
import ForgetPassword from './screens/forgetPassword/forgetPassword'
import Splash from './screens/splash/splash'
import UserInfo from './screens/user info/user info'
import Users from './screens/user/Users'
import Admins from './screens/admin/admin'
import Search from './screens/search/search'

import AddUser from './screens/add user/add user'
import setting from './screens/setting/setting';
import contactus from './screens/contactus/contactus';
import sendNotifs from './screens/send notifs/send notifs';
import Home from './screens/home/Home';
import About from './screens/about/about';
import Countries from './screens/countries/countries';
import CountryInfo from './screens/country info/country info'
import AddCountry from './screens/add country/add country'

import anoncement from './screens/anoncement/anoncement';
import anoncementInfo from './screens/anoncement info/anoncement info';
import addAnoncement from './screens/add anoncement/add anoncement';
import Questions from './screens/question/question';
import QuestionsInfo from './screens/question info/question info';
import addQuestions from './screens/add question/add question';
import Terms from './screens/terms/terms';
import Permissions from './screens/permission/permission';
import PermissionInfo from './screens/permission info/permission info';
import AddPermission from './screens/add permission/add permission';
import Supervisor from './screens/supervisor/supervisor';
import Social from './screens/social/social';
import SocialInfo from './screens/social info/social info';
import AddSocial from './screens/add social/add social';
import OccasionType from './screens/occasionType/occasionType';
import OccasionTypeInfo from './screens/occasionType info/occasionType info';
import AddOccasionType from './screens/add occasionType/add occasionType';
import Questionnaire from './screens/questionnaire/questionnaire';
import questionnaireInfo from './screens/questionnaire info/questionnaire info';
import addQuestionnaire from './screens/add questionnaire/add questionnaire';
import Occasions from './screens/occasions/occasions';
import OccasionInfo from './screens/occasion info/occasion info';
import Gifts from './screens/gifts/gifts';
import GiftInfo from './screens/gift info/gift info';
import intro from './screens/intro/intro';
import introInfo from './screens/intro info/intro info';
import addIntro from './screens/add intro/add intro';
import addPassword from './screens/add password/add password';
import Interests from './screens/interest/interest';
import InterestInfo from './screens/interest info/interest info';
import AddInterest from './screens/add interest/add interest';

import Reactions from './screens/reaction/reaction';
import ReactionInfo from './screens/reaction info/reaction info';
import AddReaction from './screens/add reaction/add reaction';
import Posts from './screens/posts/posts';
import PostInfo from './screens/post info/post info';
import timeLine from './screens/timeline/timeline';

import ProblemType from './screens/problemType/problemType';
import ProblemTypeInfo from './screens/problemType info/problemType info';
import AddProblemType from './screens/add problemType/add problemType';
import Problem from './screens/problem/problem';
import ProblemInfo from './screens/problem info/problem info';
import WaitingUsers from './screens/waiting user/waiting user';
import brand from './screens/brand/brand';
import brandInfo from './screens/brand info/brand info';
import AddBrand from './screens/add brand/add brand';
import product from './screens/product/product';
import productInfo from './screens/product info/product info';
import AddProduct from './screens/add product/add product';
import influencer from './screens/influencer/influencer'
import influencerInfo from './screens/influencer info/influencer info';
import AddInfluencer from './screens/add influencer/add influencer';
ReactDOM.render(
  
<Provider store={store}>
  <PersistGate loading={null} persistor={persistor}>
    <BrowserRouter >
      <Switch>
        <Route path={"/Login"} component={Login}/> 
        <Route exact path={"/"} component={Splash}/> 
        <Route path={"/forgetPassword"} component={ForgetPassword}/> 
        <Route path={'/addAdminPassword'} component={addPassword}/>
        <App path={'/brands'} component={brand}/>
        <App path={'/brandInfo'} component={brandInfo}/>
        <App path={'/addBrand'} component={AddBrand}/>
        <App path={'/influencers'} component={influencer}/>
        <App path={'/influencerInfo'} component={influencerInfo}/>
        <App path={'/addInfluencer'} component={AddInfluencer}/>
        <App path={'/products'} component={product}/>
        <App path={'/productInfo'} component={productInfo}/>
        <App path={'/addProduct'} component={AddProduct}/>
        <App path={'/timeLine'} component={timeLine}/> 
        <App path={'/WaitingUsers'} component={WaitingUsers}/> 
        <App path={'/intro'} component={intro}/> 
        <App path={'/introInfo'} component={introInfo}/> 
        <App path={'/Problems'} component={Problem}/> 
        <App path={'/ProblemInfo'} component={ProblemInfo}/> 
        <App path={'/posts'} component={Posts}/> 
        <App path={'/postInfo'} component={PostInfo}/> 
        <App path={'/addIntro'} component={addIntro}/>  
        <App path={'/Social'} component={Social}/> 
        <App path={'/SocialInfo'} component={SocialInfo}/> 
        <App path={'/AddSocial'} component={AddSocial}/> 
        <App path={'/ProblemTypes'} component={ProblemType}/> 
        <App path={'/ProblemTypeInfo'} component={ProblemTypeInfo}/> 
        <App path={'/AddProblemType'} component={AddProblemType}/> 

        <App path={'/Reactions'} component={Reactions}/> 
        <App path={'/ReactionInfo'} component={ReactionInfo}/> 
        <App path={'/AddReaction'} component={AddReaction}/> 

        <App path={'/Interests'} component={Interests}/> 
        <App path={'/InterestInfo'} component={InterestInfo}/> 
        <App path={'/AddInterest'} component={AddInterest}/> 

        <App path={'/Occasions'} component={Occasions}/> 
        <App path={'/occasionInfo'} component={OccasionInfo}/> 
        <App path={'/gifts'} component={Gifts}/>
        <App path={'/giftInfo'} component={GiftInfo}/> 
        <App path={'/Questionnaires'} component={Questionnaire}/> 
        <App path={'/AddQuestionnaire'} component={addQuestionnaire}/> 
        <App path={'/QuestionnaireInfo'} component={questionnaireInfo}/> 
        <App path={'/OccasionType'} component={OccasionType}/> 
        <App path={'/OccasionTypeInfo'} component={OccasionTypeInfo}/> 
        <App path={'/AddOccasionType'} component={AddOccasionType}/> 

        <App path={'/PermissionInfo'} component={PermissionInfo}/> 
        <App path={'/Permissions'} component={Permissions}/> 
        <App path={'/AddPermission'} component={AddPermission}/> 
        <App path={'/Supervisors'} component={Supervisor}/> 
        
        <App path={'/Search'} component={Search}/>
        
        <App path={'/Terms'} component={Terms}/>
        <App path={'/Questions'} component={Questions}/>
        <App path={'/questionInfo'} component={QuestionsInfo}/>
        <App path={'/AddQuestion'} component={addQuestions}/>
        <App path={'/Anoncements'} component={anoncement}/>
        <App path={'/anoncementInfo'} component={anoncementInfo}/>
        <App path={'/addAnoncement'} component={addAnoncement}/>
        <App path={'/AddCountry'} component={AddCountry}/>
        <App path={'/Countries'} component={Countries}/>
        <App path={'/CountryInfo'} component={CountryInfo}/>
        <App path={'/about'} component={About}/>
        <App path={'/Home'} component={Home}/>
        <App path={'/users'} component={Users}/>
        <App path={'/Admins'} component={Admins}/>
        <App path={'/userInfo'} component={UserInfo}/>
        <App path={'/addUser'} component={AddUser}/>
        <App path={'/Setting'} component={setting}/>
        <App path={'/ContactUs'} component={contactus}/>
        <App path={'/SendNotifs'} component={sendNotifs}/>
        
      </Switch>
    </BrowserRouter>
  </PersistGate>
</Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
